import script from "./ComHuonekorttiTableEditable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComHuonekorttiTableEditable.vue?vue&type=script&setup=true&lang=ts"

import "./ComHuonekorttiTableEditable.vue?vue&type=style&index=0&id=39b45b10&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39b45b10"]])

export default __exports__